import { Axios } from './Axios';

export async function fetchTeacherByOrg(orgId) {
  const url = `teachers?orgId=${orgId}&populate=classId orgId userId`;
  return Axios({
    url,
    method: 'get'
  });
}
